// extracted by mini-css-extract-plugin
module.exports = {"Letter":"Letter_Letter__3TWUP","Clicked":"Letter_Clicked__1Ql51","Correct":"Letter_Correct__1qyQp"};